/**
 * Inline fallback image (data URI) to avoid network requests and onError loops
 * when course/placeholder images fail to load.
 */
export const FALLBACK_IMAGE_SRC =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect fill='%23e0e0e0' width='400' height='300'/%3E%3Ctext fill='%23999' font-family='sans-serif' font-size='18' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3ENo image%3C/text%3E%3C/svg%3E";

export const handleImageError = (e) => {
  const target = e.target;
  target.onerror = null;
  target.src = FALLBACK_IMAGE_SRC;
};
